// Single source of truth for bank-statements-upload constants.
// Consumed by the funding-application section, the customer-app financing/settings
// screens, and the bankconnect component (via their dev-utils re-exports).
// Keep these here only — do not re-declare in consumer packages.
export const UPLOAD_STATEMENTS_SIZE_LIMIT_MB = 50;
export const UPLOAD_STATEMENTS_SUPPORTED_EXTENSIONS = ["pdf", "csv"];
export const UPLOAD_STATEMENTS_SUCCESS_QUERY_PARAM = "uploadStatementsSuccess";
export const ADD_MORE_STATEMENTS_QUERY_PARAM = "addStatement";
